'use client';

import React, { useState } from 'react';
import type { PublicArticle } from '@/lib/types';
import { SearchSortRow } from '@/components/browse/SearchSortRow';
import { ResultsList } from '@/components/browse/ResultsList';

/**
 * Client wrapper for the Browse results area.
 *
 * Lifts the filtered result count from `ResultsList` up to `SearchSortRow`
 * so the header can display the live match total. Both children read filter
 * state from `useBrowseFilters()` (URL-backed).
 */
export function BrowseResultsSection({ articles }: { articles: PublicArticle[] }) {
  const [count, setCount] = useState(articles.length);
  return (
    <>
      <SearchSortRow resultCount={count} />
      <ResultsList articles={articles} onCountChange={setCount} />
    </>
  );
}

export default BrowseResultsSection;
